import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

//Import Custom Compoenet
import useViewport from '../useViewport';

function ProductTypeCatalog(props) {
  const { isImageLoad = true } = props;
  let {addClass = "", product} = props;
  const { width } = useViewport();
  const breakpoint = 992;

  return (
    <div className={`product-default ${addClass}`} style={props.style}>
      <figure>
        {
          isImageLoad ? 
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category && product.category.category_slug}/${product.variants.length > 0 ? product.variants.find(variant => variant.product_variant_order === 50) ? product.variants.find(variant => variant.product_variant_order === 50).product_variant_slug : product.variants.find(variant => variant.product_variant_active).product_variant_slug : product.product_slug}`}>
              <div className="lazy-overlay bg-3"></div>
              {
                product.images.slice(0, 1).map(image => (
                  <LazyLoadImage
                    key={image.product_image_id}
                    alt={product.product_name}
                    src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
                    threshold={500}
                    effect="black and white"
                  />
                ))
              }
              {
                width > breakpoint ?
                  product.images.length >= 2 ?
                    product.images.slice(1, 2).map(image => (
                      <LazyLoadImage
                        key={image.product_image_id}
                        alt={product.product_name}
                        src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
                        threshold={500}
                        effect="black and white"
                        wrapperClassName="product-image-hover"
                      />
                    ))
                  : null
                : null
              }
            </Link>
          : null
        }
      </figure>

      <div className="product-details">
        <h3 className="product-title" style={{fontWeight: '600'}}>
          <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category && product.category.category_slug}/${product.variants.length > 0 ? product.variants.find(variant => variant.product_variant_order === 50) ? product.variants.find(variant => variant.product_variant_order === 50).product_variant_slug : product.variants.find(variant => variant.product_variant_active).product_variant_slug : product.product_slug}`}>{product.product_name}</Link>
        </h3>
        <div className="category-wrap">
          <div className="category-list">
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category && product.category.category_slug}`} className="product-category">{product.category && product.category.category_name}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductTypeCatalog;
